<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Approved Leave Reports</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="leaveType"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Leave Type"
            :items="leaveTypes"
            :error-messages="errors.collect('leaveType')"
            data-vv-name="leaveType"  
            data-vv-as="leave type"
            chips
            deletable-chips
            hide-selected
            multiple
            item-text="name"
            item-value="id"
            small-chips
            clearable
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="year"
            v-validate="'required'"
            :loading="dropdownLoading"
            :items="years"
            label="Year"
            :error-messages="errors.collect('year')"
            data-vv-name="year"  
            data-vv-as="year"
            chips
            hide-selected
            small-chips
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="department"
            :loading="dropdownLoading"
            label="Departments"
            :items="departments"
            chips
            deletable-chips
            hide-selected
            multiple
            item-text="name"
            item-value="id"
            small-chips
            clearable
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="state"
            :loading="dropdownLoading"
            label="States"
            :items="states"
            chips
            deletable-chips
            hide-selected
            multiple
            item-text="name"
            item-value="id"
            small-chips
            clearable
          />
        </v-col>
  
        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row>
            <v-btn
              class="mx-3"
              color="primary"
              :loading="loading"
              @click="generateApprovedLeaveReports"
            >
              generate
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        loading: false,
        department: [],
        departments: [],
        leaveType: null,
        leaveTypes: [],
        state: [],
        states: [],
        year: null,
        years: [],
        dropdownLoading: false,
      }
    },
    created () {
      this.dropdownLoading = true

      Promise.all([
        this.$api.departments().list(),
        this.$api.leaveTypes().list(),
        this.$api.states().list(),
        this.$api.leaveReports().approvedLeaveYears(),
      ])
        .then(([departments, leaveTypes, states, leaveReportYears]) => {
          this.departments = departments.data        
          this.leaveTypes = leaveTypes.data        
          this.states = states.data   
          this.years = leaveReportYears.data     
          
          this.dropdownLoading = false
        })
    },
    methods: {
      generateApprovedLeaveReports () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.leaveReports().generateApprovedLeaveReport(this.prepareFormData())
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Approved Leave Reports-' + this.year + '.xlsx')
                link.click()
                this.loading = false

                this.$snack({ message: 'Report downloaded successfully' })
              }).catch(() => {
                this.loading = false
                this.$snack({ color: 'error', message: 'Error! Please contact support' })
              })
          })
      },

      prepareFormData () {
        return {
          states: this.state,
          departments: this.department,
          leaveTypes: this.leaveType,
          year: this.year,
        }
      },
    },
  }
</script>
